"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandomContactList = void 0;
const ContactList_1 = require("./ContactList");
class RandomContactList extends ContactList_1.ContactList {
    randomness;
    constructor(localNodeId, maxSize, randomness = 0.20) {
        super(localNodeId, maxSize);
        this.randomness = randomness;
    }
    addContact(contact) {
        if (this.localNodeId === contact.getNodeId()) {
            return;
        }
        if (!this.contactsById.has(contact.getNodeId())) {
            const roll = Math.random();
            if (roll < this.randomness) {
                if (this.getSize() === this.maxSize && this.getSize() > 0) {
                    const toRemove = this.contactIds[0];
                    this.removeContact(toRemove);
                }
                this.contactIds.push(contact.getNodeId());
                this.contactsById.set(contact.getNodeId(), contact);
                this.emit('contactAdded', contact);
            }
        }
    }
    removeContact(id) {
        if (this.contactsById.has(id)) {
            const removed = this.contactsById.get(id);
            const index = this.contactIds.findIndex((nodeId) => (nodeId === id));
            this.contactIds.splice(index, 1);
            this.contactsById.delete(id);
            this.emit('contactRemoved', removed);
            return true;
        }
        return false;
    }
    getContacts(limit) {
        const items = (limit === undefined)
            ? this.contactIds
            : this.contactIds.slice(0, Math.max(limit, 0));
        return items.map((contactId) => this.contactsById.get(contactId));
    }
}
exports.RandomContactList = RandomContactList;
//# sourceMappingURL=RandomContactList.js.map